import { toast } from '@zerodevx/svelte-toast'

export const popup = (
	message: string,
	type: 'success' | 'warning' | 'info' | 'danger' = 'info',
	duration: number = 4000
) => {
	let bgColor = 'rgba(31,41,55,95%)'
	let textColor = 'white'
	let barColor = 'rgba(75,85,99,95%)'

	switch (type) {
		case 'success':
			textColor = '#5cb85c'
			break
		case 'warning':
			textColor = '#f0ad4e'
			break
		case 'danger':
			textColor = 'white'
			break
		case 'info':
			break
	}

	let theme = {
		'--toastBarBackground': barColor,
		'--toastColor': textColor,
		'--toastBackground': bgColor
	}
	toast.push(message, { duration, theme, pausable: true, initial: 1, next: 0 })
}

export const successToast = (m: string, d: number = 4000) =>
	toast.push(m, {
		duration: d,
		theme: {
			'--toastBarBackground': 'green'
		}
	})

export const warningToast = (m: string, d: number = 4000) =>
	toast.push(m, {
		duration: d,
		pausable: true,
		theme: {
			'--toastBarBackground': 'red'
		}
	})

export const failureToast = (m: string, d: number = 4000) =>
	toast.push(m, {
		duration: d,
		theme: {
			'--toastBarBackground': 'red'
		}
	})
